
import React from 'react';

export const CruiseInfoSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          Meet our Explorers at Sea
        </h2>
        <div className="max-w-4xl mx-auto space-y-4">
          <p className="text-lg text-gray-700 leading-relaxed">
            Explore India's West Coast with Mesmerizing Splendid Shore Excursions, Exciting Entertainment, Panoramic Seascapes, Lip Smacking Dining Options, thrilling onboard adventures, Groovy DJ Nights, Mesmerizing Live Music.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Cruise through the holidays with your loved ones.
          </p>
        </div>
      </div>
    </section>
  );
};
